// extracted by mini-css-extract-plugin
export default {"root":"action_column-module___root___c2d1a7bd"};